import { brandColors as colors } from "@/lib/palette";
import { fonts } from "@/lib/fonts";
import Footer from "@/components/ui/Footer";
import type { ReactNode } from "react";

export function SimplePage({ title, body }: { title: string; body?: ReactNode }) {
  return (
    <div className="min-h-dvh" style={{ backgroundColor: colors.cream }}>
      <main className="pt-32 pb-16 px-6 max-w-3xl mx-auto">
        <h1
          className="text-4xl mb-4"
          style={{ fontFamily: fonts.logo, color: colors.navy }}
        >
          {title}
        </h1>
        <p
          className="text-base"
          style={{ fontFamily: fonts.body, color: `${colors.navy}cc` }}
        >
          {body ?? "Content coming soon."}
        </p>
      </main>
      <Footer />
    </div>
  );
}
